import { OFFER_IMAGE_BACKGROUND } from 'components/offers/offerImages';
import React, { useCallback } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Box, Button, CardMedia } from "@mui/material";

const OfferCover = ({ company, companyImage, image, isPreview }) => {
  const location = useLocation();

  const navigate = useNavigate();
  const [, setSearchParams] = useSearchParams();

  const isNotSearch = location?.pathname !== "/search"; 

  const handleClick = useCallback(() => {
    if (isPreview) return;

    if (isNotSearch) {
      navigate(`/search?businessId=${company}`);
    } else {
      setSearchParams({ businessId: company }); 
    }
  }, [company, navigate, isNotSearch, isPreview, setSearchParams]);

  return (
    <CardMedia image={image} sx={{ position: "relative", aspectRatio: "16 / 9", backgroundColor: OFFER_IMAGE_BACKGROUND, backgroundSize: "contain", backgroundRepeat: "no-repeat", backgroundPosition: "center" }}>
      <Box p={2} sx={{ position: "absolute", top: 0, left: 0 }}>
        {companyImage && <Button
          onClick={handleClick}
          size="small"
          sx={{
            background: "#fff",
            padding: 0.5,
            "&:hover": {
              background: "#fff",
            },
          }}
        >
          <img height={36} src={companyImage} alt={company} style={{ display: "block" }} />
        </Button>}
      </Box>
    </CardMedia>
  );
};

export default OfferCover;
